import { atom } from "recoil";

export const viewTenantsDrawerState = atom({
    key: "viewTenantsDrawerState",
    default: null,
})